import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreateMoneyPage as CreateMoneyPageMutation,
    CreateMoneyPageVariables,
    UrlCreateInput,
} from 'nutshell-graphql-types';

import CREATE_MONEY_PAGE from '../mutations/create-money-page.graphql';

export const useCreateMoneyPage = (): {
    createMoneyPage: (arg1: UrlCreateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [createMoneyPage, {loading, error}] = useMutation<
        CreateMoneyPageMutation,
        CreateMoneyPageVariables
    >(CREATE_MONEY_PAGE);

    return {
        createMoneyPage: (input: UrlCreateInput) => createMoneyPage({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
